module.exports = __webpack_public_path__ + "img/fdfaec6.jpg";